import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./yearpicker.css";
import { FiChevronDown } from "react-icons/fi";

// Custom input button
const CustomMonthInput = forwardRef(({ value, onClick }, ref) => (
    <button type="button" className="custom-year-picker-btn" onClick={onClick} ref={ref}>
        {value || "Select Month"}
        <FiChevronDown className="custom-year-icon" />
    </button>
));

const MonthPicker = ({ selectedMonth, setSelectedMonth }) => {
    return (
        <div className="year-picker-container">
            <DatePicker
                selected={selectedMonth}
                onChange={(date) => setSelectedMonth(date)}
                dateFormat="MMM"          // Output: Jan, Feb, Mar
                showMonthYearPicker       // key change
                customInput={<CustomMonthInput />}
            />
        </div>
    );
};

export default MonthPicker;
